import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';

type AlertType = 'warning' | 'notice';

@Component({
  selector: 'app-alert-note',
  templateUrl: './alert-note.component.html',
  styleUrls: ['./alert-note.component.scss'],
})
export class AlertNoteComponent implements AfterViewInit {
  @Input() type: AlertType = 'notice';
  @Input() header: string = 'Note';
  @Input() description: string = '';

  @ViewChild('textRef') textRef!: ElementRef<HTMLParagraphElement>;
  expanded = false;
  showMore = false;

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    const el = this.textRef.nativeElement;
    const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
    const maxHeight = lineHeight * 3;
    this.showMore = el.scrollHeight > maxHeight;
  }

  toggleExpanded(): void {
    this.expanded = !this.expanded;
  }
}
